import { FunctionComponent } from "react";

import RegisterForm from "@src/modules/Public/Register/RegisterForm";
import { PublicPanel } from "@src/modules/Public/shared/components";

const Register: FunctionComponent = () => (
  <PublicPanel>
    <RegisterForm />
  </PublicPanel>
);

export default Register;
